// Emailの最大長（Sentinelが最短なのでそれに合わせる）
export const EMAIL_MAX_LENGTH = 100;

// プロフィール関連の文字列長上限
export const PROFILE_COLUMN_LENGTH = 255;

// 姓名の最大文字数（Sentinelが最短なのでそれに合わせる）
export const NAME_MAX_LENGTH = 50;

// パスワード文字数（Sentinelが最短なのでそれに合わせる）
export const PASSWORD_MAX_LENGTH = 30;

// TELの最大文字数（(255-ハイフン2文字)を入力項目数で等分）
export const TEL_MAX_LENGTH = 84;

// 郵便番号の最大文字数（アメリカの9桁を上限とする）
export const POSTAL_CODE_MAX_LENGTH = 9;

// Entitlementの検索文字列の文字数制限
export const SEARCH_TEXT_MAX_LENGTH = 36;

// 日本である判定に使用する識別子
export const COUNTRY_JP = "JP";

